import { EntityApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const showEntityApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${EntityApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
